import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useProducts from '../../hooks/useProducts';
import { addItemToCart } from '../../redux/slices/cartSlice';
import { toggleWishlistItem } from '../../redux/slices/wishlistSlice';
import { toggleCompareItem } from '../../redux/slices/compareSlice';
import SectionTitle from '../../components/SectionTitle';
import SingleShop from '../../components/Shop';
import Button from '../../components/Button';

const Shop = () => {
  const { products, status, error } = useProducts(); // Use the custom hook to fetch product data and manage loading/error states
  const dispatch = useDispatch();

  const displayProducts = products.slice(0, 8); // To display first 8 products

  // Dispatch the action to add the item to cart
  const handleAddToCart = (product) => {
    dispatch(
      addItemToCart({
        product: product,
      })
    );
  };

  // Dispatch the action to toggle the item to the wishlist
  const handleToggleWishlist = (product) => {
    dispatch(toggleWishlistItem(product));
  };

  // Dispatch the action to toggle the item to the Compare
  const handleToggleCompare = (product) => {
    dispatch(toggleCompareItem(product));
  };

  // Render a loading message while the products are being fetched
  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  // Render an error message if the fetch request fails
  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  return (
    <div id="it-shop" className="it-shop-area fix pb-90">
      <div className="container">
        <div className="it-shop-title-wrap mb-65">
          <div className="row align-items-end">
            <div className="col-xl-6 col-md-6">
              <SectionTitle
                itemClass="it-shop-title-box"
                subTitleClass="it-section-subtitle"
                subTitle="Premium Items"
                titleClass="it-section-title"
                title="Featured Products"
              />
            </div>
            <div className="col-xl-6 col-md-6">
              <div className="it-shop-button text-md-start">
                <Link className="it-btn-theme" to="/shop-column-4">
                  <Button btnText="View all items" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {displayProducts.map((product) => (
            <div
              key={product.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30"
            >
              <SingleShop
                productId={product.id}
                thumbnailImg={product.thumbnail}
                badgeTitle={product.badgeTitle}
                title={product.title}
                price={product.price}
                rating={product.rating}
                category={product.category}
                images={product.images}
                inStock={product.inStock}
                onAddToCart={() => handleAddToCart(product)}
                onToggleWishlist={() => handleToggleWishlist(product)}
                onToggleCompare={() => handleToggleCompare(product)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Shop;
